import { useLocation } from 'react-router-dom';

/**
 * Routes where interrupting modals (the "What's New" splash, the PDPA consent
 * modal, the Review prompt) should NOT auto-open — because the user is either
 * mid-transaction (billing/checkout/onboarding) or focused on reading/working
 * (guide, signal check). Keeping these flows uninterrupted protects conversion
 * and avoids the splash overlapping the page.
 */
export const SUPPRESSED_ROUTE_PREFIXES = [
  '/billing',
  '/checkout',
  '/payment',
  '/onboarding',
  '/subscription-expired',
  '/signal-check',
  '/guide',
  '/user-guide',
  '/help',
  '/forms/builder',
];

const matches = (pathname, prefix) =>
  pathname === prefix || pathname.startsWith(prefix + '/');

/**
 * Returns true when the current route is one where interrupting modals should
 * be suppressed. Pass a custom list of path prefixes to override the default.
 *
 * @param {string[]} [prefixes] - path prefixes to suppress on
 * @returns {boolean}
 */
export function useSuppressModalsOnRoutes(prefixes = SUPPRESSED_ROUTE_PREFIXES) {
  const { pathname } = useLocation();
  return prefixes.some((p) => matches(pathname, p));
}

export default useSuppressModalsOnRoutes;
